import { style, keyframes } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';
import { reducedMotion, mobile } from '@/shared/ui/theme/media';

const fadeIn = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

export const overlay = style({
  position: 'fixed',
  inset: 0,
  background: vars.shadow.overlay,
  backdropFilter: 'blur(4px) saturate(1.3)',
  WebkitBackdropFilter: 'blur(4px) saturate(1.3)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: vars.elevation.overlay,
  padding: vars.spacing.padding.xl,
  animation: `${fadeIn} ${vars.animation.duration.medium} ${vars.animation.easing.easeOut}`,
  '@media': {
    [reducedMotion]: { animation: 'none' },
    [mobile]: { padding: vars.spacing.padding.lg },
  },
});

export const panelBox = style({
  width: '100%',
  maxWidth: '1180px',
  height: 'min(90vh, 880px)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderRadius: vars.spacing.borderRadius.lg,
  outline: 'none',
});
